<template>
  <el-card :body-style="{ padding: '0px' }"
           style="width: 100%">
    <el-table
        :data="coursesForTable"
        style="width: 100%"
        :cell-style="{padding: '0', 'min-height': '1px'}"
        @cell-mouse-enter="hoverOnTimetableGrid"
    size="mini">
      <el-table-column
          type="index"
          :index="(index) => courseOption.timeslot[index]"
      width="20">
      </el-table-column>
      <el-table-column
          v-for="d of courseOption.weekday"
          :key="d"
          :label="nToWeekday[d]"
          :prop="d">
        <template slot-scope="scope">
          <course-grid :d="d" :scope="scope"/>
        </template>

      </el-table-column>

    </el-table>

  </el-card>
</template>
<script>

import CourseGrid from "@/components/Element/CourseGrid/CourseGrid";

export default {
  name: 'course-timetable',
  components: {CourseGrid},
  data(){
    return{
      nToWeekday:{
        1:'MON',2:'TUE',3:'WED',4:'THR',5:'FRI',6:'SAT',7:'SUN'
      }
    }
  },
  computed: {
    coursesForTable() {
      let coursesSlot = this.$store.state.courseGroups[this.$store.state.usingCourse].scheduleSlots
      let days = this.courseOption.weekday
      let slots = this.courseOption.timeslot
      let convertedCourses = []
      for (let s of slots) {
        let slotCourses = {}
        for (let d of days) {
          // console.log(d+s)
          slotCourses[d] = coursesSlot[d + s].slice()
        }
        convertedCourses.push(slotCourses)
      }

      let preview = this.courseOption.previewCourse
      if(preview){
        if(!this.coursesGroup.list.includes(preview)){
          preview = Object.assign({}, preview)
          preview.isPreview = true
          for(let s of preview.timeSchedules){
            let d = s[0]
            let slot = this.courseOption.timeslot.indexOf(s[1])
            let row = convertedCourses[slot]
            if(row){
              row[d].push(preview)
            }
          }
        }
      }
      return convertedCourses
    }
  },
  methods:{
    hoverOnTimetableGrid(){
      // console.log(row,col,cell)
    }
  }
}
</script>
